import React from 'react';

export const formatByLines = (lines: (string | undefined | null)[]) => {
  return lines.filter(Boolean).map((line, index) => (
    <React.Fragment key={index}>
      {index > 0 && <br />}
      {line?.trim()}
    </React.Fragment>
  ));
};
